<template>
<div>
    <div class="px-4" v-if="view == 'data'">
        <div class="d-flex justify-content-center mt-2">
            <div class="w-100 border-box-main">
                <div class="d-flex responsive-search px-2">
                    <div class="input-group input-group mb-3 mx-lg-1 w-100">
                        <span class="input-group-text text-white bg-main"><i class="fas fa-search"></i></span>
                        <input type="text" class="form-control form-control" style="background-color: #f9e79f" placeholder="BUSCAR NOMBRE" v-model="filter.name" @keyup.enter="mtdChangeFilter()"/>
                    </div>
                    <div class="d-flex align-items-center mb-3 btn-home">
                    <!-- <div class="d-flex align-items-center mb-3 w-25 btn-home">
                        <button
                            type="button"
                            class="btn btn-bm-noradius me-2"
                            style="flex: 1; min-width: 120px; white-space: nowrap;"
                            @click="openOc()"
                        >
                            OC Pendiente
                        </button> -->
                        <button
                            class="btn btn-primary rounded-circle"
                            type="button"
                            @click="mtdAddItemCarro()"
                        >
                            <i class="far fa-cart-plus fa-sm"></i>
                        </button>
                        <button  v-if="page !== 'ocPendienteAct'"
                            class="btn btn-primary rounded-circle ms-1"
                            type="button"
                            @click="returnView()"
                        >
                            <i class="fas fa-arrow-left"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="cuerpo mt-1">
            <ViewActivo
                v-if="page == 'viewActivo'"
                ref="activosComponent"
                :actives="Activos"
                @mtdAddItemCarrito="mtdAddItemCarrito"
            />
        </div>
    </div>
    <!-- <div v-else-if="view == 'ocPendienteAct'">
      <OcPendienteAct
        @mtdBack="retroceder"
      />
    </div> -->
    <div v-if="page == 'ocPendienteAct'">
        <h6 class="px-4 mb-3">
            <i class="fas fa-shopping-cart"></i> ORDENES DE COMPRAS - PENDIENTES
        </h6>
      <OcPendienteAct
        @mtdBack="retroceder"
      />
    </div>
    <cModalViewCarritoActVue
    ref="cModalViewCarritoActVue"
      :title="modalCarrito.title"
      :boo_modal="modalCarrito.modal_form"
      :datos="datos"
      @closeModalCarrito="closeModalCarrito"
      @mtdDelete="mtdDelete"
      @registerCarrito="registerCarrito"
      :valorType="modalCarrito.valorType" 
      :valorTypeVen="modalCarrito.valorTypeVen"
      @openModalBrand="openModalBrand"
      @mtdAddBrand="mtdAddBrand"
    />
    <cModalAddMarcaAct :title="modalBrand.title" :boo_modal="modalBrand.modal_form" :item="modalBrand.item" :pos="modalBrand.pos" :search="modalBrand.search" 
    @mtdCloseModal="mtdCloseModal" @addBrand="addBrand" />
    <cModalPlus :title="modalPlus.title" :boo_modal="modalPlus.modal_form" :id="modalPlus.id" 
    @mtdCloseModalPlus="mtdCloseModalPlus"/>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</div>
</template>

<script>
import {mapActions} from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import ViewActivo from "@/components/Logistica/pages/Ordendecompra/ViewActives.vue";
import cModalViewCarritoActVue from "@/components/Logistica/modals/Oc/cModalViewCarritoAct.vue";
import cModalAddMarcaAct from '@/components/Logistica/modals/Oc/cModalAddMarcaAct.vue';
import cModalPlus from '@/components/Logistica/modals/Oc/Actives/cModalPlus.vue';
import OcPendienteAct from "@/components/Logistica/pages/Ordendecompra/OcPendienteAct";
export default {
    name: 'logistica-ordendecompra-Activos',
    components: {
        SweetAlert,
        ViewActivo,
        cModalViewCarritoActVue,
        OcPendienteAct,
        cModalAddMarcaAct,
        cModalPlus
    },
    data() {
        return {
            swal: null,
            filter: {
                name: "",
            },
            Activos: [],
            datos: [],
            //page: "",
            page: "ocPendienteAct",
            view: "data",
            modalCarrito: {
                title: "",
                modal_form: false,
                valorType: null,
                valorTypeVen: null,
            },
            modalBrand: {
                title: "",
                modal_form: false,
                pos: null,
                item: {},
                search: null,
            },
            modalPlus: {
                title: "",
                modal_form: false,
                id: null,
            },
        };
    },
    computed: {
    },
    watch: {
    },
    created() {
      
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdaddAct: function () {
            this.modal= {
                title: "REGISTRAR ORDEN DE COMPRA",
                modal_form: true,
            };
        },

        mtdChangeFilter() {
            this.post({
                url: this.$store.getters.get__url + "/Active/detalles/filter",
                token: this.$store.getters.get__token,
                params: this.filter,
            })
            .then((response) => {
                this.Activos = response.data;
                this.page = "viewActivo";
                if (this.$refs.activosComponent) {
                    this.$refs.activosComponent.clear();
                };
                this.mtdHide();
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        mtdTypeChanges() {
            this.post({
                url: this.$store.getters.get__url + "/logistics/typeChanges",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.modalCarrito.valorType = response.compra;
                this.modalCarrito.valorTypeVen = response.venta;
            })
        },

        mtdHide() {
            (this.filter = {
                name: "",
            })
        },

        mtdAddItemCarrito: function (payload) {
            this.mtdTypeChanges();
            let datosdetail =  {
                    id : payload.id,
                    cat_id: payload.cat_id,
                    cat_name: payload.cat_name,
                    sub_id: payload.sub_id,
                    sub_name: payload.sub_name,
                    name: payload.name,
                    state: payload.state,
                    price: payload.price,
                    quantity: 1,
                    brands: payload.brands,
                    searchBrand: null,
                    newBrand: null,
                    newBrandId: null,
                    igv_num: 0
            }
            this.modalCarrito.title = "OC ACTIVOS";
            this.datos.push(datosdetail);
            this.modalCarrito.modal_form = true;
        },

        mtdAddItemCarro: function () {
            this.mtdTypeChanges();
            this.modalCarrito.title = "OC ACTIVOS";
            this.modalCarrito.modal_form = true;
        },

        //Modal Carrito
        closeModalCarrito: function () {
            this.modalCarrito = {
                title: "",
                modal_form: false,
                valorType: null,
                valorTypeVen: null,
            };
        },

        mtdDelete(idAct) {
            const indice = this.datos.findIndex(item => item.id === idAct);

            if (indice !== -1) {
                this.datos.splice(indice, 1);
            }
        },

        registerCarrito(data){
            if(data){
                this.datos = [];
            }
            //this.page = "";
            this.page = "ocPendienteAct";
            //this.view = "ocPendienteAct";
        },

        openOc() {
            this.view = "ocPendienteAct";
        },

        retroceder: function () {
            this.view = "data";
        },

        //Modal Brand
        openModalBrand: function(item, index){
            this.modalBrand = {
                title: "Lista de Marcas",
                modal_form: true,
                pos: index,
                item: item,
                search: item.searchBrand
            }
        },

        mtdCloseModal: function () {
            this.modalBrand = {
                title: "",
                modal_form: false,
                pos: null,
                item: {},
                search: null,
            }
        },

        addBrand: function (payload, pos) {
            this.$nextTick(() => {
                this.$refs.cModalViewCarritoActVue.addBrandCarrito(payload, pos);
            });
        },

        //Agregar Marca en caso no dese escojer ninguna
        mtdAddBrand:function (id) {
            this.modalPlus = {
                title: "Agregar Nueva Marca",
                modal_form: true,
                id: id,
            }
        },

        mtdCloseModalPlus: function (){
            this.modalPlus = {
                title: "",
                modal_form: false,
                id: null,
            }
        },

        //Retornar a la vista anterior
        returnView: function() {
            this.$refs.SweetAlert.showConfirmSimple2("", "¿Desea regresar a la Vista de OC Pendiente", "warning", "Confirmar")
            .then((result) => {
                if (result.value) {
                    this.page = "ocPendienteAct";
                }
            });
        }
    },
};
</script>
